import createPersistedState from "use-persisted-state";
import { PersistedStorageKeys } from "constants/persisted-storage-keys";

export const useSummaryTagGroup = createPersistedState<string | undefined>(
    PersistedStorageKeys.LiveSummaryTagGroupSelected
);
